<template>
  <el-container class="layout">
    <!-- 桌面端侧边栏 -->
    <el-aside v-if="!isMobile" width="200px" class="aside">
      <div class="brand">企业团餐订餐</div>
      <el-menu :default-active="$route.path" router background-color="#1F2D3D" text-color="#bfcbd9" active-text-color="#409EFF">
        <el-menu-item v-for="m in menus" :key="m.path" :index="m.path">
          <i :class="m.icon"></i>
          <span>{{ m.title }}</span>
        </el-menu-item>
      </el-menu>
    </el-aside>

    <!-- 手机端抽屉导航 -->
    <el-drawer
      :visible.sync="drawerOpen"
      direction="ltr"
      size="220px"
      :show-close="false"
      :with-header="false"
      custom-class="mobile-drawer"
    >
      <div class="drawer-brand">企业团餐订餐</div>
      <el-menu :default-active="$route.path" router background-color="#1F2D3D" text-color="#bfcbd9" active-text-color="#409EFF" @select="drawerOpen = false">
        <el-menu-item v-for="m in menus" :key="m.path" :index="m.path">
          <i :class="m.icon"></i>
          <span>{{ m.title }}</span>
        </el-menu-item>
      </el-menu>
    </el-drawer>

    <el-container>
      <el-header class="header" height="52px">
        <div class="header-left">
          <i v-if="isMobile" class="el-icon-s-fold menu-toggle" @click="drawerOpen = true"></i>
          <span class="page-title">{{ $route.meta.title }}</span>
        </div>
        <span class="user">
          <span class="username">{{ user.username }}</span>
          <span class="role-tag">{{ user.role === 'SUPER' ? '超级管理员' : '运营管理员' }}</span>
          <el-button size="mini" type="text" @click="logout">退出</el-button>
        </span>
      </el-header>
      <el-main class="main">
        <router-view />
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import { getUser, clearAuth, isSuper } from '@/utils/auth'

export default {
  data() {
    return {
      isMobile: window.innerWidth < 768,
      drawerOpen: false
    }
  },
  computed: {
    user() { return getUser() },
    isSuper() { return isSuper() },
    menus() {
      const all = [
        { path: '/stats', title: '数据看板', icon: 'el-icon-data-analysis' },
        { path: '/export', title: '报表导出', icon: 'el-icon-download' },
        { path: '/history', title: '历史查询', icon: 'el-icon-time' },
        { path: '/menu', title: '菜单管理', icon: 'el-icon-food', super: true },
        { path: '/setting', title: '订餐设置', icon: 'el-icon-setting', super: true },
        { path: '/employee', title: '顾客管理', icon: 'el-icon-user', super: true }
      ]
      return all.filter(m => !m.super || this.isSuper)
    }
  },
  mounted() {
    this.onResize = () => {
      this.isMobile = window.innerWidth < 768
      if (!this.isMobile) this.drawerOpen = false
    }
    window.addEventListener('resize', this.onResize)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize)
  },
  methods: {
    logout() {
      clearAuth()
      this.$router.push('/login')
    }
  }
}
</script>

<style>
.layout { height: 100%; }
.aside { background: #1F2D3D; }
.brand { color: #fff; font-size: 16px; font-weight: 600; text-align: center; padding: 18px 0; }
.aside .el-menu { border-right: none; }
.header { background: #fff; display: flex; justify-content: space-between; align-items: center; border-bottom: 1px solid #e6e6e6; padding: 0 16px; }
.header-left { display: flex; align-items: center; gap: 10px; }
.page-title { font-weight: 600; font-size: 15px; }
.menu-toggle { font-size: 22px; color: #409EFF; cursor: pointer; }
.user { color: #606266; font-size: 14px; display: flex; align-items: center; gap: 6px; }
.role-tag { color: #909399; font-size: 12px; }
.main { background: #f5f6f7; }

/* 手机端抽屉 */
.mobile-drawer .drawer-brand {
  color: #fff; background: #1F2D3D;
  font-size: 15px; font-weight: 600; text-align: center; padding: 18px 0;
}
.mobile-drawer .el-menu { border-right: none; background: #1F2D3D; }
.mobile-drawer .el-drawer__body { padding: 0; background: #1F2D3D; height: 100%; }

/* 全局移动端适配 */
@media (max-width: 768px) {
  .main { padding: 10px !important; }
  .el-card__body { padding: 12px !important; }
  .el-message { min-width: auto; max-width: 90vw; }
}
</style>
